module.exports = __webpack_public_path__ + "static/media/card_bg_5.1a97b623.png";